import script from "./BaseSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseSwitch.vue?vue&type=script&setup=true&lang=js"

import "./BaseSwitch.vue?vue&type=style&index=0&id=46ff7817&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46ff7817"]])

export default __exports__